import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const customStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@400;500&display=swap');
`;

export default function Terms() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = customStyles;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0f1c 0%, #0d1525 100%)',
      fontFamily: "'DM Sans', sans-serif",
      color: 'white'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(255,255,255,0.02)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        padding: '20px 40px'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '18px'
            }}>
              ⚡
            </div>
            <span style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: '18px',
              fontWeight: '600',
              color: 'white'
            }}>
              BrainForge
            </span>
          </Link>
          <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '60px 40px'
      }}>
        <h1 style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: '40px',
          fontWeight: '700',
          marginBottom: '12px'
        }}>
          Terms of Service
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '48px' }}>
          Last updated: December 2025
        </p>

        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: '16px',
          padding: '32px'
        }}>
          {[
            {
              title: '1. Acceptance of Terms',
              content: 'By accessing and using BrainForge, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.'
            },
            {
              title: '2. Description of Service',
              content: 'BrainForge provides a platform for multi-AI collaboration, allowing users to interact with multiple AI models simultaneously. You must provide your own API keys from third-party AI providers (Anthropic, OpenAI, xAI, DeepSeek).'
            },
            {
              title: '3. User Responsibilities',
              content: 'You are responsible for: maintaining the confidentiality of your account, all activities under your account, ensuring your use complies with applicable laws, and the costs associated with your API key usage from third-party providers.'
            },
            {
              title: '4. API Keys',
              content: 'You must obtain and provide your own API keys from supported AI providers. You are solely responsible for the costs incurred through your API usage. We encrypt and securely store your API keys but are not liable for any charges from third-party providers.'
            },
            {
              title: '5. Subscription and Billing',
              content: 'Subscriptions are billed on a recurring basis (monthly or annually). You may cancel at any time; access continues until the end of your billing period. Refunds are handled according to our Refund Policy.'
            },
            {
              title: '6. Prohibited Uses',
              content: 'You may not use our service to: violate any laws, infringe on intellectual property rights, distribute malware, attempt to gain unauthorized access, or engage in any activity that disrupts the service.'
            },
            {
              title: '7. Intellectual Property',
              content: 'The BrainForge platform, including its design, features, and content, is owned by SellFast.Now. You retain ownership of content you create using our service.'
            },
            {
              title: '8. Limitation of Liability',
              content: 'BrainForge is provided "as is" without warranties. We are not liable for any indirect, incidental, or consequential damages arising from your use of the service.'
            },
            {
              title: '9. Changes to Terms',
              content: 'We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.'
            },
            {
              title: '10. Contact',
              content: 'For questions about these Terms, please contact us at support@multipowerai.com.'
            }
          ].map((section, i) => (
            <div key={i} style={{ marginBottom: i < 9 ? '28px' : 0 }}>
              <h2 style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: '18px',
                fontWeight: '600',
                color: '#667eea',
                marginBottom: '12px'
              }}>
                {section.title}
              </h2>
              <p style={{
                color: 'rgba(255,255,255,0.7)',
                lineHeight: '1.7',
                fontSize: '15px'
              }}>
                {section.content}
              </p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: '40px',
          display: 'flex',
          gap: '24px',
          justifyContent: 'center'
        }}>
          <Link to="/privacy" style={{ color: '#667eea', textDecoration: 'none', fontSize: '14px' }}>
            Privacy Policy
          </Link>
          <Link to="/refund-policy" style={{ color: '#667eea', textDecoration: 'none', fontSize: '14px' }}>
            Refund Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
